import { PublicRouteKey } from "@/routes/publicRoutes";

export const broadKeywords = ["thrive", "grants", "funding programs", "web3", "blockchain", "crypto"];

export const SEO: Record<PublicRouteKey, { title: string; description: string; keywords: string[] }> = {
  "page.dashboard": {
    title: "Discover Thrive",
    description:
      "Explore Funding Program opportunities, track your applications, and view stats tailored to your activity.",
    keywords: [...broadKeywords, "dashboard", "ecosystems", "stats"],
  },
  "page.grant": {
    title: "Program Details",
    description: "Discover program details and apply for funding opportunities.",
    keywords: [...broadKeywords, "program details", "grant", "funding opportunities", "apply", "milestones"],
  },
  "page.invite": {
    title: "Join Thrive",
    description: "Use your invite code to join Thrive and start building.",
    keywords: [...broadKeywords, "invite code", "join thrive", "sign up", "builders", "community"],
  },
} as const;
